'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './mail-recipient-list.routes';

export class MailRecipientListComponent {

  constructor(dialogs,$uibModal, RecipientListService, ClientErrorsService, Auth, $location) {
    'ngInject';
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.RecipientListService = RecipientListService;
    this.ClientErrorsService = ClientErrorsService;
    this.Auth = Auth;
    this.$location = $location;

    this.RecipientListService.query((data) => {
      this.mailLists = data;
    }, err => {
      this.fetchError(err);
      console.log("Could not retrieve mail lists from server.")
    })
  }

  fetchError(err) {
    this.Auth.getCurrentUser(user => {
      let auth = !!user;

      this.ClientErrorsService.save({
        message: (err instanceof Error) ? err.toString() : err.status + ": " + err.statusText,
        stack: (err instanceof Error) ? err.stack : "",
        route: this.$location.url(),
        auth,
        username: (user) ? user.firstName +  " " + user.lastName : "",
        email: (user) ? user.email : "",
        userId: (user) ? user._id : "",
        clientTime: new Date()
      });
    });
  }

  delete(list) {
    var that = this;

    var listText = "<br/><br/><b>" + list.name + "</b><br/><p>" + list.description + "</p>";

    var dlg = this.dialogs.confirm("Delete Recipient List?", "Do you really want to delete this list?" + listText);
    dlg.result.then(() => {
      // OK delete it
      that.RecipientListService.delete({id: list._id},
        () => {
          that.mailLists = that.mailLists.filter(function( obj ) {
            return obj._id !== list._id;
          });
        },
        err => {
          that.fetchError(err);
          alert("Could not delete recipient list");
        });
    }, () => {
      // Cancel
    });
  }

  openPreviewModal(list) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'jsonViewer',
      resolve: {
        config: function() {
          return {
            data: list.recipients
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function () { /* ok */ },
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduuApp.mailRecipientList', [uiRouter])
  .config(routes)
  .component('mailRecipientList', {
    template: require('./mail-recipient-list.html'),
    controller: MailRecipientListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/messaging/mail/recipient/list/mail-recipient-list.component.js